import { Box, Typography, Link, styled, useTheme } from '@mui/material';
import { FC } from 'react';
import { Recommendation } from '../../types';

const RecommendationImages = styled(Link)`
  .recommendation-image-top {
    left: 10%;
    top: 10%;
  }

  .recommendation-image-bottom {
    right: 10%;
    bottom: 10%;
  }

  &:hover {
    .recommendation-image-top {
      transform: translate(-5px, -5px);
    }

    .recommendation-image-bottom {
      transform: translate(5px, 5px);
    }
  }
`;

const RecommendationImage = styled('img')`
  position: absolute;
  width: 60%;
  aspect-ratio: 1 / 1;
  transition: transform 0.3s;
`;

interface Props {
  recommendation: Recommendation;
  onClick: () => void;
}

const RecommendationResult: FC<Props> = ({ recommendation, onClick }) => {
  const theme = useTheme();

  return (
    <Box onClick={onClick}>
      <RecommendationImages
        href={recommendation.cta}
        sx={{
          width: '100%',
          borderRadius: 8,
          aspectRatio: '1 / 1',
          backgroundColor: theme.palette.grey[700],
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            width: '66%',
            borderRadius: '50%',
            border: '2px solid',
            borderColor: theme.palette.grey[50],
            aspectRatio: '1 / 1',
          }}
        />
        {recommendation.relevance && (
          <Typography
            data-testid="recommendation-results-badge"
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              backgroundColor: 'secondary.main',
              color: theme.palette.grey[50],
              paddingX: 1,
              paddingY: '0.3rem',
              fontWeight: 700,
              borderRadius: 4,
            }}
          >
            {recommendation.relevance}%
          </Typography>
        )}
        <RecommendationImage
          className="recommendation-image-top"
          src={recommendation.images[0]}
        />
        <RecommendationImage
          className="recommendation-image-bottom"
          src={recommendation.images[1]}
        />
      </RecommendationImages>
      <Typography
        data-testid="recommendation-results-description"
        fontSize={16}
        lineHeight="24px"
        marginTop={1}
      >
        {recommendation.description}
      </Typography>
    </Box>
  );
};

export default RecommendationResult;
